
import { Observable } from 'rxjs';

export abstract class PaymentGatewayData  {
    abstract getOrderIdPayment(data:PGOrderDetDto,tenantId:string,branchId:string);
    abstract verifyPaymentSignature(data,tenantId:string,branchId:string): Observable<any>;
    abstract postCommissionTrans(data:PGCommissionTransactionPostDto):Observable<any>
}

export interface PGOrderDetDto {
  amount: number;
  currencyCode: string;
  tenantId: string;
  branchId: string;
  createdBy: number;
  createdDate: Date;
}

export interface PaymentCheckout {
  orderId: string;
  currency: string;
  amount: number;
  name: string;
  email: string;
  mobile: string;
  key: string;
  description: string;
  image: string;
}
export interface PGCommissionTransactionPostDto {
  paymodeType: string;
  billAmount: number;
  regId: string;
  admId?: number | null;
  opBillId?: number | null;
  ipBillId?: number | null;
  ph_BillId?: number | null;
  tenantId: string;
  branchId: string;
  createdBy: number;
  createdDate: Date;
  updatedBy?: number | null;
  updateDate?: string | null;
  paymentReferenceId: string;
  apptId: number;

}

